import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

export const styles = theme => ({
	root: {
		display: 'block',
	},
	asterick: {
		color: theme.palette.error.main,
	},
});

const ReduxFormInput = ({
	classes,
	description,
	input: { onBlur, onFocus, value, ...input },
	labelShrink,
	meta: { error, touched },
	placeholder,
	required,
	...custom
}) => (
	<FormControl className={classes.root} error={touched && !!error}>
		{placeholder && (
			<InputLabel htmlFor={input.name} shrink={labelShrink}>
				{placeholder}
				{required && !!error ? <span className={classes.asterick}> *</span> : null}
			</InputLabel>
		)}
		<Input
			id={input.name}
			onBlur={() => onBlur(value)} // sometimes focus and blur events pass back an incorrect value
			onFocus={() => onFocus(value)} // so manually specify the value in the callback
			value={value}
			{...input}
			{...custom}
		/>
		{(touched && !!error && <FormHelperText>{error}</FormHelperText>) ||
			(description && <FormHelperText>{description}</FormHelperText>)}
	</FormControl>
);

ReduxFormInput.propTypes = {
	input: PropTypes.shape({
		name: PropTypes.string.isRequired,
		onFocus: PropTypes.func.isRequired,
		onBlur: PropTypes.func.isRequired,
		value: PropTypes.string.isRequired,
	}),
	description: PropTypes.string,
	meta: PropTypes.shape({ touched: PropTypes.bool, error: PropTypes.string }),
	placeholder: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
	}).isRequired,
	required: PropTypes.bool,
	labelShrink: PropTypes.bool,
};

ReduxFormInput.defaultProps = {
	input: {},
	description: null,
	meta: {},
	placeholder: null,
	required: false,
	labelShrink: undefined,
};

export default withStyles(styles, { name: 'ReduxFormInput' })(ReduxFormInput);
